import * as utils from "@/utils/httpUtils.js"
import config from '@/config/index.js'

//删除文件
function delDoc(id) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/delete?id=" + id;
        utils.httpDelete(url).then((res) => {
            resolve(res);    
        })        
    })
}

//更新文件
function updateDoc(id, name) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/edit";
        let param = {"id": id, "name": name};
        console.log("param", param);
        console.log("url", url);
        utils.httpPut(url, param).then((res) => {
            resolve(res);   
        })       
    })
}

//添加文件
function addDoc(fileName,filePath,parentId, coverPath) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/add";
        let param = { "name": fileName, "type": 2, cover: coverPath, "parentId": parentId, "filePath": filePath };
        utils.httpPost(url, param).then((res) => {
            resolve(res);  
        })        
    })
}


//新建文件
function createDoc(fileName,content, docType, parentId) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/create";
        let param = { "name": fileName, "type": 2, content: content,  docType: docType,  "parentId": parentId };
        utils.httpPost(url, param).then((res) => {
            resolve(res);  
        })        
    })
}

//获取文件详情
function getDoc(id) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/queryById?id=" + id;
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}

//获取指定目录下的文件
function getDocList(parentId) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/list?parentId=" + parentId + "&pageNo=1&pageSize=1000"
        utils.httpGet(url).then((res) => {
            resolve(res);
        })      
    })
}

//获取用户目录
function getUserDir() {

    return new Promise(function (resolve) {
        let url = config.configData.api_url  + "/business/lzDocs/list?type=1&userId=" + sessionStorage.getItem("userId") + "&pageNo=1&pageSize=1000";
        utils.httpGet(url,{}).then((res) => {
            resolve(res);
        }) 
       
    })
}

//上传文件
function uploadFile(file) {

    return new Promise(function (resolve) {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('fileType', 'other')
        let url = config.configData.api_url  + "/sys/common/uploadPlus";
        utils.httpFile(url,formData).then((res) => {
            resolve(res);
        })
    })
}

//上传文件
function uploadFileA(file) {

    return new Promise(function (resolve) {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('biz', 'doc')
        let url = config.configData.api_url  + "/sys/common/uploadA";
        utils.httpFile(url,formData).then((res) => {
            resolve(res);
        })
    })
}

//更新文件
function updateFile(docId, fileUrl) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzFiles/add";
        let param = {"fileUrl": fileUrl, "docId": docId, "delFlag":"0" };
        utils.httpPost(url, param).then((res) => {
            resolve(res);
        })       
    })
}

function changeDir(docId, dirId) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/changeDir";
        let param = {"id": docId, "parentId": dirId};
        utils.httpPost(url,param).then((res) => {
            resolve(res);
        })             
    })
}

//点赞
function likeDoc(docId) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url +   "/business/lzDocs/like?id=" + docId;
        utils.httpGet(url,{}).then((res) => {
            resolve(res);
        })            
    })
}

//收藏
function collectDoc(docId) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url +   "/business/lzDocs/collect?id=" + docId;
        utils.httpGet(url,{}).then((res) => {
            resolve(res);
        })         
    })
}

//获取导航菜单
function getNav(id) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/getNavData?id=" + id
        utils.httpGet(url).then((res) => {
            resolve(res);
        })       
    })
}

//添加目录
function addDir(name, parentId) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/add";
        let param = { "name": name, "type": 1, "parentId": parentId };
        utils.httpPost(url, param).then((res) => {
            resolve(res);
        })       
    })
}

//添加文档文档分享
function addDocShare(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzShare/add";
        utils.httpPost(url, data).then((res) => {
            resolve(res);  
        })        
    })
}


//更新文档分享
function editDocShare(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzShare/edit";
        utils.httpPut(url, data).then((res) => {
            resolve(res);  
        })        
    })
}


//获取分享码信息
function getDocShare(code) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzShare/getDocShare?code=" + code
        utils.httpGet(url).then((res) => {
            resolve(res);
        })       
    })
}


//获取要编辑文件
function getByEditFile(id) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzFiles/getByEditFile?id=" + id;
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}


//添加文档分享
function updateUserFile(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzFiles/updateUserFile";
        utils.httpPost(url, data).then((res) => {
            resolve(res);  
        })        
    })
}


//获取分享信息
function getShare(id) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzShare/queryById?id=" + id;
        utils.httpGet(url).then((res) => {
            resolve(res);  
        })        
    })
}

//获取分享id
function getShareId(code,pwCode) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzShare/getIdByPwCode?code=" + code + "&pwCode=" + pwCode;
        utils.httpGet(url).then((res) => {
            resolve(res);  
        })        
    })
}

//根据分享id获取文件信息
function getFileByShareId(id) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzShare/getFileById?id=" +id;
        utils.httpGet(url).then((res) => {
            resolve(res);  
        })        
    })
}


//根据分享id获取文件信息
function getTempQrCode(str) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/wx/user/getTempQrCode?scene_str=" + str;
        utils.httpGet(url).then((res) => {
            resolve(res);  
        })        
    })
}

//根据扫描登录状态
function checkScanState(str) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/sys/checkScanState?scene_str=" + str;
        //let url = "http://lzwd.anyroad.com.cn/api/sys/checkScanState?scene_str=" + str;
        utils.httpGet(url).then((res) => {
            resolve(res);  
        })        
    })
}

//更新姓名
function updateRealname(id, name) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/sys/user/updateRealname";
        let param = {"id": id, "realname": name};
        console.log("url", url);
        utils.httpPut(url, param).then((res) => {
            resolve(res);   
        })       
    })
}

//获取要编辑文件
function getFileList(doctId) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzFiles/getListByDocId?docId=" + doctId;
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}

//查看历史
function viewList(filter) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzView/listAll?filter=" + filter
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}

//收藏历史
function collectList(filter) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzCollect/listAll?filter=" + filter
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}

//回收站
function recoveryList(filter) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/recoveryList?filter=" + filter
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}

//恢复
function recovery(id) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/recovery?id=" + id;
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}

//彻底删除
function remove(id) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/remove?id=" + id
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}


//彻底删除
function removeAll() {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/removeAll"
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}

//获取系统文件
function getSysDocList() {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/sysList"
        utils.httpGet(url).then((res) => {
            resolve(res);
        })      
    })
}


//用户数据统计
function userTotal() {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/userTotal"
        utils.httpGet(url).then((res) => {
            resolve(res);
        })      
    })
}


//消息列表
function messageList() {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzMessage/listByUser"
        utils.httpGet(url).then((res) => {
            resolve(res);
        })      
    })
}

//未读消息合计
function noReadMsgCount() {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzMessage/noReadCount"
        utils.httpGet(url).then((res) => {
            resolve(res);
        })      
    })
}


//已读
function readMessage(id) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzMessage/read?id=" + id 
        utils.httpGet(url).then((res) => {
            resolve(res);
        })      
    })
}

//我的文档数
function docCount() {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/docCount"
        utils.httpGet(url).then((res) => {
            resolve(res);
        })      
    })
}

//已读
function allRead() {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzMessage/allRead" 
        utils.httpGet(url).then((res) => {
            resolve(res);
        })      
    })
}

//删除已读
function delReadMsg() {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzMessage/delReadMsg" 
        utils.httpGet(url).then((res) => {
            resolve(res);
        })      
    })
}



//更新文件
function editDoc(id, name, content) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/edit";
        let param = {"id": id, "name": name, "content": content};
        console.log("url", url);
        utils.httpPut(url, param).then((res) => {
            resolve(res);   
        })       
    })
}


//发消息
function sendMsgs(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzMessage/sendMsgs";
        console.log("url", url);
        console.log("body", data);
        utils.httpPost(url, data).then((res) => {
            resolve(res);   
        })       
    })
}

//获取要编辑文件
function editLogs(id) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzFiles/editLogs?id=" + id;
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}

//更新用户
function editUser(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/sys/user/edit";
        console.log("url", url);
        utils.httpPut(url, data).then((res) => {
            resolve(res);   
        })       
    })
}


//下表更新列表
function sendUpdateList(docId) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzMessage/listBySend?docId=" + docId
        utils.httpGet(url).then((res) => {
            resolve(res);
        })      
    })
}


function getPdfFile(fileId) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzFiles/getPdfFile?id=" + fileId
        utils.httpGet(url).then((res) => {
            resolve(res);
        })      
    })
}


//改名
function docRename(id, name) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/rename";
        let param = {"id": id, "name": name};
        console.log("param", param);
        console.log("url", url);
        utils.httpPut(url, param).then((res) => {
            resolve(res);   
        })       
    })
}

//添加便签
function saveNote(content) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzNote/save";
        let param = { "content": content };
        utils.httpPost(url, param).then((res) => {
            resolve(res);  
        })        
    })
}

//添加便签
function getNote() {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzNote/getByUser" 
        utils.httpGet(url).then((res) => {
            resolve(res);
        })      
    })
}


//添加到我的版本
function appendToMy(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/appendToMy";
        utils.httpPost(url, data).then((res) => {
            resolve(res);   
        })       
    })
}


//获取文件详情
function getFile(id) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzFiles/queryById?id=" + id;
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}


//文档搜索
function getDocAllList(filter) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/listAll?filter=" + filter
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}

//获取我的文件信息
function getMyFile(docId) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzFiles/getMyFile?docId=" + docId;
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}

//获取复制文件信息
function getCopyFile(id) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzFiles/getCopyFile?id=" + id;
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}


//获取回复文件信息
function getReplyFile(id) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzFiles/getReplyFile?id=" + id;
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}

//保存回复信息
function saveReplyFile(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzFiles/saveReplyFile";
        console.log(url);
        utils.httpPost(url, data).then((res) => {
            resolve(res);
        })        
    })
}

//获取回复清单
function getReplyList(id) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzFiles/getReplyList?id=" + id;
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}


//删除回复
function deleteReply(id) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzFiles/deleteReply?id=" + id;
        utils.httpDelete(url).then((res) => {
            resolve(res);    
        })        
    })
}


function addTodo(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzTodo/add";
        console.log(url);
        utils.httpPost(url, data).then((res) => {
            resolve(res);
        })        
    })
}

function editTodo(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzTodo/edit";
        console.log(url);
        utils.httpPut(url, data).then((res) => {
            resolve(res);
        })        
    })
}

function deleteTodo(id) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzTodo/delete";
        console.log(url);
        utils.httpDelete(url, {id:id}).then((res) => {
            resolve(res);
        })        
    })
}

function listTodo(param) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzTodo/list"
        console.log(url);
        utils.httpGet(url, param).then((res) => {
            resolve(res);
        })        
    })
}

function saveAllHtml(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzHtml/saveAll";
        console.log(url);
        utils.httpPost(url, data).then((res) => {
            resolve(res);
        })        
    })
}

function updateHtml(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzHtml/update";
        console.log(url);
        utils.httpPut(url, data).then((res) => {
            resolve(res);
        })        
    })
}


function saveHtmlReply(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzHtml/reply";
        console.log(url);
        utils.httpPost(url, data).then((res) => {
            resolve(res);
        })        
    })
}


function testItemFinish(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzHtml/testItemFinish";
        console.log(url);
        utils.httpPost(url, data).then((res) => {
            resolve(res);
        })        
    })
}

function getHtmlData(dataId) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzHtml/getData?id=" + dataId;
        console.log(url);
        utils.httpGet(url, {}).then((res) => {
            resolve(res);
        })        
    })
}


function getDocTotalInfo(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/getTotalInfo";
        console.log(url);
        utils.httpGet(url, data).then((res) => {
            resolve(res);
        })        
    })
}


function getDocQueryInfo(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/getQueryInfo";
        console.log(url);
        utils.httpGet(url, data).then((res) => {
            resolve(res);
        })        
    })
}


function importTest(file,fileId) {

    return new Promise(function (resolve) {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('fileId', fileId)
        let url = config.configData.api_url  + "/business/lzFiles/importTest";
        utils.httpFile(url,formData).then((res) => {
            resolve(res);
        })
    })
}

function getTestHtml(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzHtml/getTestHtml";
        console.log(url);
        utils.httpPost(url, data).then((res) => {
            resolve(res);
        })        
    })
}

function getQuestionHtml(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzHtml/getQuestionHtml";
        console.log(url);
        utils.httpPost(url, data).then((res) => {
            resolve(res);
        })        
    })
}

function answerQuestion(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzHtml/answerQuestion";
        console.log(url);
        utils.httpPost(url, data).then((res) => {
            resolve(res);
        })        
    })
}


function getQuestionData(dataId) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzHtml/getQuestionData?id=" + dataId;
        console.log(url);
        utils.httpGet(url, {}).then((res) => {
            resolve(res);
        })        
    })
}


function postQuestion(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzHtml/postQuestion";
        console.log(url);
        utils.httpPost(url, data).then((res) => {
            resolve(res);
        })        
    })
}

function importQuestion(file,fileId) {

    return new Promise(function (resolve) {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('fileId', fileId)
        let url = config.configData.api_url  + "/business/lzFiles/importQuestion";
        utils.httpFile(url,formData).then((res) => {
            resolve(res);
        })
    })
}


function cloneQuestion(fileId) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzFiles/cloneQuestion?id=" + fileId;
        console.log(url);
        utils.httpGet(url, {}).then((res) => {
            resolve(res);
        })        
    })
}


//获取题库文档
function getMyQuestionDocs() {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzDocs/getMyQuestionDocs" 
        utils.httpGet(url).then((res) => {
            resolve(res);
        })       
    })
}

function getQuestionTitles(fileId) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzHtml/getQuestionTitles?fileId=" + fileId 
        utils.httpGet(url).then((res) => {
            resolve(res);
        })       
    })
}

function copyQuestion(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzFiles/copyQuestion";
        console.log(url);
        utils.httpPost(url, data).then((res) => {
            resolve(res);
        })        
    })
}



function addPlan(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzPlan/add";
        console.log(url);
        utils.httpPost(url, data).then((res) => {
            resolve(res);
        })        
    })
}

function editPlan(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzPlan/edit";
        console.log(url);
        utils.httpPut(url, data).then((res) => {
            resolve(res);
        })        
    })
}

function deletePlan(planDate) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzPlan/del";
        console.log(url);
        utils.httpPost(url, {planDate:planDate}).then((res) => {
            resolve(res);
        })        
    })
}

function listPlan() {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzPlan/list"
        console.log(url);
        utils.httpGet(url).then((res) => {
            resolve(res);
        })        
    })
}

function queryPlan(date) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzPlan/query"
        utils.httpPost(url, {planDate: date}).then((res) => {
            resolve(res);
        })        
    })
}

function savePlan(data) {

    return new Promise(function (resolve) {
        let url = config.configData.api_url + "/business/lzPlan/save";
        console.log(url);
        utils.httpPost(url, data).then((res) => {
            resolve(res);
        })        
    })
}


export  {
    delDoc,getDoc,updateDoc,getUserDir,uploadFileA,updateFile,changeDir,likeDoc,collectDoc,getDocList,getNav,
    uploadFile,addDoc,addDir,addDocShare,editDocShare,getDocShare,createDoc,getByEditFile,updateUserFile,getShare,
    getShareId,getFileByShareId, getTempQrCode,checkScanState,updateRealname,getFileList,viewList,collectList,recoveryList,
    recovery,remove,getSysDocList,userTotal,messageList,noReadMsgCount,readMessage,docCount,allRead,delReadMsg,editDoc,
    sendMsgs,editLogs,editUser,sendUpdateList,getPdfFile,docRename,saveNote,getNote,appendToMy,getFile,getDocAllList,
    getMyFile,getCopyFile,getReplyFile,saveReplyFile,getReplyList,deleteReply,addTodo,editTodo,deleteTodo,listTodo,
    saveAllHtml,updateHtml,saveHtmlReply,testItemFinish,getHtmlData,getDocTotalInfo,getDocQueryInfo,importTest,
    getTestHtml,getQuestionHtml,answerQuestion,getQuestionData,postQuestion,importQuestion,removeAll,cloneQuestion,
    getMyQuestionDocs,getQuestionTitles,copyQuestion,addPlan,editPlan,deletePlan,listPlan,queryPlan,savePlan
}







// WEBPACK FOOTER //
// ./src/api/api.js